<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const route = useRoute()
const router = useRouter()

interface NavItem {
  path: string
  label: string
  show: boolean
}

const navItems = computed<NavItem[]>(() => {
  const items: NavItem[] = [
    { path: '/tasks/', label: 'Tasks', show: true },
    { path: '/image-tasks/', label: 'Изображения', show: true },
  ]
  if (auth.isAdmin) {
    items.push({ path: '/admin/providers/', label: 'Providers', show: true })
    items.push({ path: '/admin/stats/', label: 'Stats', show: true })
    items.push({ path: '/admin/storages/', label: 'Storages', show: true })
    items.push({ path: '/admin/logs/', label: 'Logs', show: true })
    items.push({ path: '/admin/validators/', label: 'Validators', show: true })
    items.push({ path: '/admin/users/', label: 'Users', show: true })
    items.push({ path: '/admin/spam-formulas/', label: 'Spam formulas', show: true })
    items.push({ path: '/admin/settings/', label: 'Settings', show: true })
  }
  return items.filter((i) => i.show)
})

function isActive(path: string): boolean {
  if (path === '/tasks/' || path === '/image-tasks/') {
    return route.path.startsWith(path)
  }
  return route.path === path
}

function go(path: string): void {
  router.push(path)
}
</script>

<template>
  <aside class="sidebar">
    <ul>
      <li
        v-for="item in navItems"
        :key="item.path"
        :class="{ active: isActive(item.path) }"
        @click="go(item.path)"
      >
        {{ item.label }}
      </li>
    </ul>
  </aside>
</template>
